import { useContext, useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'

import { LocalStorageContext, SHARE_FUND_CODE } from '../local-storage/localStorage'
import { Icons, Link, Stack, Text } from '..'
import { queries } from '../../graphql'
import { useBranding } from '../../hooks'

export function NoticeHeader() {
  const { addSubscriber, getValue, removeSubscriber } = useContext(LocalStorageContext)
  const [val, setVal] = useState(getValue(SHARE_FUND_CODE))
  const val2 = getValue(SHARE_FUND_CODE)

  const { data: meData } = useQuery(queries.user.me, { fetchPolicy: 'cache-only' })
  const isCharity = (meData?.me?.charityUsers || []).length > 0

  const { data: pendingFundClaimData } = useQuery(queries.fundClaims.myPendingFundClaimInvites, {
    fetchPolicy: 'cache-and-network',
    skip: isCharity,
  })
  const pendingFundClaimInvites = pendingFundClaimData?.myPendingFundClaimInvites ?? []

  useEffect(() => {
    const listener = () => setVal(getValue(SHARE_FUND_CODE))
    addSubscriber(SHARE_FUND_CODE, listener)
    return () => {
      removeSubscriber(SHARE_FUND_CODE, listener)
    }
  })

  const { accentColor, accentTextColor } = useBranding()

  return (
    <Stack>
      {val2 && (
        <ClaimShareFundNotice {...JSON.parse(val2 ?? {})} accentColor={accentColor} accentTextColor={accentTextColor} />
      )}
      {pendingFundClaimInvites.map((invite) => (
        <PendingAdvisorInviteBanner
          key={invite.id}
          invite={invite}
          accentColor={accentColor}
          accentTextColor={accentTextColor}
        />
      ))}
    </Stack>
  )
}

function PendingAdvisorInviteBanner({ invite, accentColor, accentTextColor }) {
  const advisorLabel = invite.advisorName || 'An advisor'
  return (
    <LinkNotice
      link={`/claim-fund/${invite.token}`}
      accentColor={accentColor}
      accentTextColor={accentTextColor}
      sx={{ width: '100%' }}
    >
      <Icons.ManagingUserOnFund />
      <Text.Body sx={{ paddingLeft: 1, paddingRight: 1 }}>
        Financial Advisor Access Request: {advisorLabel} has requested to advise on your Giving Fund.
      </Text.Body>
      <Icons.ManagingUserOnFund />
    </LinkNotice>
  )
}

function ClaimShareFundNotice({ id: shareId, code, accentColor, accentTextColor }) {
  return (
    <LinkNotice
      link={`/receive-a-daf-transfer/${shareId}/${code}`}
      accentColor={accentColor}
      accentTextColor={accentTextColor}
      sx={{ width: '100%' }}
    >
      <Icons.Gift />
      <Text.Body sx={{ paddingLeft: 1, paddingRight: 1 }}>Claim Your Shared Funds</Text.Body>
      <Icons.Gift />
    </LinkNotice>
  )
}

function LinkNotice({ link, children, accentColor, accentTextColor, sx }) {
  return (
    <Link
      to={link}
      sx={{
        display: 'flex',
        flexGrow: 1,
        backgroundColor: accentColor,
        color: accentTextColor,
        padding: 1,
        justifyContent: 'center',
        textDecoration: 'none',
        ...sx,
      }}
    >
      {children}
    </Link>
  )
}
